import { render, staticRenderFns } from "./SetTemplate.vue?vue&type=template&id=4a1dc9b8"
import script from "./SetTemplate.vue?vue&type=script&lang=js"
export * from "./SetTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports